import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'
import pic6 from './pic6.jpg'

const Page = () => {

    const detail = 
        {
            id:1,
            imgSrc:pic1,
            ini:'IJL PRESTO Scientific Advisory Board Meeting at Chiang Mai University',
            href:'',
            element:'',
            topic:'',
            inform: `On October 14-15, 2025, Asst. Prof. Dr. Woottichai Khamduang, in collaboration with Dr. Nicole Ngo-Giang-Huong, coordinator of the PRESTO International Joint Laboratory (IJL), Faculty of Associated Medical Sciences, Chiang Mai University, 
                    organized the Scientific Advisory Board Meeting of IJL PRESTO at the University Academic Service Center (UNISERV), Chiang Mai University.  
                    
                    <br><br> The meeting was opened by Prof. Dr. Sakorn Pornprasert, Dean of the Faculty of Associated Medical Sciences, 
                    who welcomed Dr. Xavier Mari, IRD Representative in Thailand, along with experts from Thailand and abroad. Key speakers included Asst. Prof. Dr. Woottichai Khamduang (Faculty of AMS, CMU), Dr. Nicole Ngo-Giang-Huong (Researcher, UMR 224 MIVEGEC),
                    Dr. Dorothée Missé (Research Director, UMR 224 MIVEGEC, IRD, France), Dr. Sabrina Locatelli (Co-coordinator of IJL PRESTO in Laos, Researcher, UMR 224 MIVEGEC, and IRD Representative in Laos) and Asst. Prof. Dr. Marco J. Haenssgen (Faculty of Social Sciences, CMU). 
                    
                    <br><br> The meeting provided a platform for exchanging academic knowledge, sharing research progress and achievements under the PRESTO project, and defining strategic directions for future collaboration. Discussions focused on One Health, preparedness for emerging and re-emerging infectious diseases, 
                    and the strengthening of international academic cooperation networks. 
                    
                    <br><br> The event was further enriched by valuable insights and recommendations from distinguished advisory board members, including:
                    <ul>
                        <li><b>Emeritus Prof. Dr. Suwat Chariyalertsak: </b> Faculty of Public Health, Chiang Mai University </li> 
                        <li><b>Assoc. Prof. Dr. Saengduen Moonsom: </b> Faculty of Tropical Medicine, Mahidol University </li> 
                        <li><b>Assoc. Prof. Dr. Tsan-Yuk Lam: </b> School of Public Health, University of Hong Kong </li> 
                        <li><b>Assoc. Prof. Dr. Vijaykrishna Dhanasekaran: </b> School of Public Health, University of Hong Kong </li>
                        <li><b>Asst. Prof. Sysay Palamy: </b> Faculty of Pharmacy, University of Health Sciences, Lao PDR. </li>
                    </ul>   
                    `,
                    
            link1: `https://www.facebook.com/permalink.php?story_fbid=807807295556758&id=100089824854973`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        },
        {
            imageSrc: pic6,
            alt: 'pic6',
            title: 'pic6',
            thumbnailImageSrc: pic6
        }
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Page;
